import { listingHighlightsTab as schema } from 'web/schemas/contentful/_schema.mjs';
import { fakeProps } from 'web/schemas/contentfulTestData';

const TestData = {
  header: 'Listing Highlights',
  currencyData: {
    conversion: {
      ARS: 819.695995,
      BSD: 1,
      BZD: 2.015675,
      CAD: 1.3465,
      CLP: 914.396155,
      COP: 3926.259995,
      CRC: 515.793055,
      EUR: 0.91871,
      KYD: 0.83333,
      MXN: 17.163635,
      PEN: 3.73501,
      UYU: 39.276740000000004,
      USD: 1,
    },
  },
  tabs: [
    {
      type: 'standard',
      header: 'Property',
      tabListings: [
        {
          header: 'Zoning',
          content: 'ER',
        },
        {
          header: 'Exclusions',
          content: 'Tenant Personal Property',
        },
        {
          header: 'Attached Garage Y/N',
          content: 'Y',
        },
        {
          header: 'Association',
          content: 'Yes',
        },
        {
          header: 'Special Listing Conditions',
          content: '18',
        },
        {
          header: 'Lot Size Acres',
          content: '2.61',
        },
        {
          header: 'Lot Size (Sq Ft)',
          content: '113,691',
        },
        {
          header: 'Carport',
          content: '3',
        },
        {
          header: 'Tax Annual Ammount',
          content: '$6,892',
        },
        {
          header: 'Living Area (Sq Ft)',
          content: '113,691',
        },
        {
          header: 'County',
          content: 'El Paso',
        },
        {
          header: 'Tax Year',
          content: '2020',
        },
        {
          header: 'Views Last 7 Days',
          content: '18',
        },
      ],
    },
    {
      type: 'community',
      header: 'Community',
      tabListings: [
        {
          content: '37',
          header: 'Median Age',
          img: '/assets/bar-graph.svg',
        },
        {
          content: '5,068',
          header: 'Population Density (Per Sq Mile)',
          img: '/assets/population-density.svg',
        },
        {
          content: '64%',
          header: 'College Educated',
          img: '/assets/education.svg',
        },
        {
          content: '$90,853',
          header: 'Estimated Median Income',
          img: '/assets/coins.svg',
        },
        {
          content: '5,895',
          header: 'Estimated Total Home Owners',
          img: '/assets/house.svg',
        },
        {
          content: '3,096',
          header: 'Estimated Total Renters',
          img: '/assets/piechart.svg',
        },
        {
          content: '66%/34%',
          header: 'Estimated Owner/Renter Divide',
          img: '/assets/scales.svg',
        },
        {
          content: '2',
          header: 'Estimated Avg. Household Size',
          img: '/assets/2people.svg',
        },
        {
          content: '20,240',
          header: 'Total Population',
          img: '/assets/pyramid.svg',
        },
      ],
    },
    {
      type: 'school',
      header: 'Schools',
      tabListings: [
        {
          header: 'Edison Elementary School',
          content: 'Public, PreK-5 • Serves this home',
          rating: 6,
          students: '563',
          distance: '0.2mi',
          reviewAvg: 4,
          reviewNum: 15,
        },
        {
          header: 'Bryant Webster K-8 School',
          content: 'Public, PreK-8 • Serves this home',
          rating: 5,
          students: '446',
          distance: '1.9mi',
          reviewAvg: 5,
          reviewNum: 10,
        },
        {
          header: 'Skinner Middle School',
          content: 'Public, 6-8 • Serves this home',
          rating: 7,
          students: '631',
          distance: '0.7mi',
          reviewAvg: 4,
          reviewNum: 22,
        },
        {
          header: 'Denver Public Montesorri Junior/Senior High School',
          content: 'Public, 7-12 • Serves this home',
          rating: 3,
          students: '213',
          distance: '1.9mi',
          reviewAvg: 0,
          reviewNum: 0,
        },
        {
          header: 'North High School',
          content: 'Public, 9-12 • Serves this home',
          rating: 3,
          students: '1235',
          distance: '1.2mi',
          reviewAvg: 4,
          reviewNum: 8,
        },
      ],
    },
    {
      type: 'community',
      header: 'Test 2',
      tabListings: [
        {
          header: '37',
          content: 'Median Age',
          img: '/assets/bar-graph.svg',
        },
        {
          header: '5,068',
          content: 'Population Density (Per Sq Mile)',
          img: '/assets/population-density.svg',
        },
        {
          header: '64%',
          content: 'College Educated',
          img: '/assets/education.svg',
        },
        {
          header: '$90,853',
          content: 'Estimated Median Income',
          img: '/assets/coins.svg',
        },
        {
          header: '5,895',
          content: 'Estimated Total Home Owners',
          img: '/assets/house.svg',
        },
        {
          header: '3,096',
          content: 'Estimated Total Renters',
          img: '/assets/piechart.svg',
        },
        {
          header: '66%/34%',
          content: 'Estimated Owner/Renter Divide',
          img: '/assets/scales.svg',
        },
        {
          header: '2',
          content: 'Estimated Avg. Household Size',
          img: '/assets/2people.svg',
        },
        {
          header: '20,240',
          content: 'Total Population',
          img: '/assets/pyramid.svg',
        },
      ],
    },
    {
      type: 'community',
      header: 'Test 3',
      tabListings: [
        {
          header: '37',
          content: 'Median Age',
          img: '/assets/bar-graph.svg',
        },
        {
          header: '5,068',
          content: 'Population Density (Per Sq Mile)',
          img: '/assets/population-density.svg',
        },
        {
          header: '64%',
          content: 'College Educated',
          img: '/assets/education.svg',
        },
        {
          header: '$90,853',
          content: 'Estimated Median Income',
          img: '/assets/coins.svg',
        },
        {
          header: '5,895',
          content: 'Estimated Total Home Owners',
          img: '/assets/house.svg',
        },
        {
          header: '3,096',
          content: 'Estimated Total Renters',
          img: '/assets/piechart.svg',
        },
        {
          header: '66%/34%',
          content: 'Estimated Owner/Renter Divide',
          img: '/assets/scales.svg',
        },
        {
          header: '2',
          content: 'Estimated Avg. Household Size',
          img: '/assets/2people.svg',
        },
        {
          header: '20,240',
          content: 'Total Population',
          img: '/assets/pyramid.svg',
        },
      ],
    },
  ],
};

export default fakeProps(schema, TestData);
